import { FC, ReactNode } from 'react';
import { withStyles } from 'vopay';

import styles from './Feature.module.scss';

import { Title } from '#shared/components/UI';

const cn = withStyles(styles);

type FeatureProps = {
  icon: ReactNode;
  title: string;
  desc: string;
};

const Feature: FC<FeatureProps> = ({ icon, title, desc }) => {
  return (
    <div className={cn('feature')}>
      <div className={cn('icon')}>{icon}</div>

      <div>
        <Title level="6">{title}</Title>
        <p>{desc}</p>
      </div>
    </div>
  );
};

export default Feature;
